import { Link } from 'react-router-dom';
import { Form, Image, } from 'semantic-ui-react';
import styled from 'styled-components';
import bgImage from '../../assets/images/bg_login.jpg';
import { styleSheet } from '../../assets/styles/global';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;

  background-image: url(${bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const MainLogo = styled(Image)`
  width: 8rem;
  margin-bottom: 4rem;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 5rem 3rem;
  background: rgba(255, 255, 255, 0.9);
  width: 40rem;
  border-radius: 3rem;
`;

export const ContainerForget = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 1rem;

  font-size: 1.6rem;
`;

export const DivRemember = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckboxLabel = styled.label`
  margin-left: 1rem;
  color: #2c2c2c;
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  width: 100%;
`;

export const FormLabel = styled.label`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #2c2c2c;
`;

export const ButtonLogin = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  font-size: 1.8rem;
  width: 70%;
  margin-top: 5rem;

  background: ${styleSheet.colorMain};
  color: ${styleSheet.shape};
  border: 0;
  border-radius: 0.8rem;
  cursor: pointer;
  transition: 0.2s background ease-out;

  &:hover {
    background: ${styleSheet.colorMainDark}
  }
`;

export const InputLogin = styled.input`
  display: flex;
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 0.1rem solid #c3c3c3;
`;

export const LinkForgotPass = styled(Link)`
  text-decoration: none;
  color: ${styleSheet.colorMain};
  transform: 0.2s color ease-out;

  &:hover {
    color: ${styleSheet.colorMainDark};
  }
`;

export const MobileViewContainer = styled.div`
  font-family: ${styleSheet.mainFont};
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-radius: 3rem;
`;

export const MobileViewTitlte = styled.div`
  font-size: 2.4rem;
  margin-top: 1rem;
  color: #2c2c2c;
`;

export const MobileViewTitle = styled.div`
  font-family: ${styleSheet.mainFont};
  font-size: 2.4rem;
  font-weight: bold;
  margin: 1rem 0;
  color: ${styleSheet.defaultFontColor};
`;

export const MobileViewDescription = styled.div`
  font-family: ${styleSheet.mainFont};
  font-size: 1.4rem;
  margin-bottom: 2rem;
  font-weight: 600;
  color: ${styleSheet.darkerGrey};
`;

export const MobileContainerButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const MobileButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 1.5rem 2.4rem;
  background-color: ${styleSheet.colorMainDark};
  margin-top: 2rem;
  border-radius: 10px;
`;

export const MobileButtonText = styled.div`
  font-size: 1.6rem;
  color: #fff;
`;

export const LoginBox = styled.div`
  width: 40rem;
  min-height: 55rem;
  background: rgba(255, 255, 255, 0.9);
  padding: 5rem 2rem;
  border-radius: 2rem;
  z-index: 2;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Logotipo = styled.img`
  height: 8rem;
  margin-bottom: 3rem;
`;

export const Footer = styled.footer`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 6rem;

  color: #6c6c6c;
  font-weight: 600;
  font-size: 1.2rem;
`;

export const InputLabel = styled.label`
  font-family: ${styleSheet.mainFont};
  font-size: 1.4rem !important;
  margin-bottom: 2rem;
  font-weight: 600 !important;
  color: ${styleSheet.darkerGrey}!important;
`;

export const CheckboxContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2rem;
  font-weight: 500 !important;
  line-height: 10px !important;
    .ui.toggle.checkbox label {
      padding-top: 0;
  }
  .ui.toggle.checkbox .box, .ui.toggle.checkbox label {
    color: #6c6c6c;
}
`;

export const LinkContainer = styled.div`
  width: 100%;
  font-size: 1.3rem;
  display: flex;
  justify-content: center;
  /* margin-top: 1rem; */
  font-weight: 600;
  color: #1E90FF !important;
`;

export const LoginBoxMobile = styled.div`
  width: 36rem;
  /* min-height: 55rem; */
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5rem 2rem;
  border-radius: 2rem;
  z-index: 2;
`;